import axios from 'axios'

// create an axios instance
const service = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: 'https://api.hndnews.com/' , // api 的 base_url process.env.VUE_APP_BASE_API

  // baseURL: 'http://192.168.49.157:4006/' ,
  // baseURL: 'http://192.168.49.157:6006/' ,
  // baseURL: 'http://192.168.49.146:6006/' ,
  // baseURL: 'https://test-hsapp.hndnews.com/' ,
  timeout: 300 * 1000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   config.headers['token'] = store.getters.token
    // } else if (getToken()) {
    //   config.headers['token'] = getToken()
    // }
    config.headers['version'] = '2.7.2'
    return config
  },
  error => {
    // Do something with request error
    console.log(error, 123) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  response => {
    if (response.status === 200) {
      return response.data
    }

    return response
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
